import { z } from 'zod';

import { zodBlockerSchema } from '../validations';

export const zodCompanyDeletionCheckResponseSchema = z.object({
  blockers: z.array(zodBlockerSchema),
  deletable: z.boolean(),
});
